/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ChangeEvent,
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { toastText } from "utils/utils";
import AddShipmentManuallyModal from "./AddShipmentManuallyModel";
import UploadShipmentModal from "./AddShipmentModal";
import ShipmentTable from "./ShipmentTable";
import { ShipmentProps } from "./types";
import ConfirmDelete from "components/Global/confirmDeleteModel";

import { EditOutlined, UploadOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import { TableActionHeader } from "components/Global";
import { getApi, deleteApiWithData } from "redux/apis";
import { AddSvg } from "utils/svgs";
import { SEARCHABLE_FIELDS } from "../../../utils/shipment";
import { useSelector, useDispatch } from "react-redux";
import { useInventoryCounts } from "hooks";
import { setServiceCenterSelection } from "redux/slice/inventoryServiceCenterSlice";

// Define interface for fetch parameters
interface FetchParams {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: string;
  searchValue?: string;
  searchFields?: string[];
  serviceCenterId?: any;
  salesOrderNumber?: any[];
  status?: string[];
  resetPagination?: boolean;
  skipDuplicateCheck?: boolean;
  forceRefresh?: boolean;
}

const ShipmentComponent = (props: ShipmentProps) => {
  const { refetchCounts } = props;
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [refetchAgain, setRefetchAgain] = useState(0);
  const [allShipmentData, setAllShipmentData] = useState<any>([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchFields, setSearchFields] = useState<string[]>(
    SEARCHABLE_FIELDS.map((field) => field.value)
  );
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedRecordId, setSelectedRecordId] = useState<string | null>(null);

  const [isAddShipmentModalOpen, setIsUploadShipmentModalOpen] =
    useState(false);
  const [isAddShipmentManuallyModalOpen, setIsAddShipmentManuallModalOpen] =
    useState(false);
  const [selectedShipment, setSelectedShipment] = useState<any>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    { id: string; quantity: number; shipmentId: string }[]
  >([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  // Get service center state from Redux
  const { selectedServiceCenter, selectedServiceCenters } = useSelector(
    (state: any) =>
      state.inventoryServiceCenter || {
        selectedServiceCenter: null,
        selectedServiceCenters: [],
      }
  );
  const [selectedSalesOrderNumbers, setSelectedSalesOrderNumbers] = useState(
    []
  );
  const [filtersReset, setFiltersReset] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
  const [baseLoading, setBaseLoading] = useState(false);

  // OPTIMIZATION: Add refs to track API calls and prevent duplicates
  const isApiCallInProgress = useRef(false);
  const lastApiCallParams = useRef<string>("");
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  const profileData = useSelector((state: any) => state?.userProfile?.data);
  const isServiceCenter =
    profileData?.companyRoles[0]?.role?.roleName === "Service Center";
  const isAdmin =
    profileData?.companyRoles[0]?.role?.roleName === "Admin 3nStar";
  const isEmployee2 =
    profileData?.companyRoles[0]?.role?.roleName === "3nStar Employee 2";
  const roleName = profileData?.companyRoles[0]?.role?.roleName;
  const userId = profileData.id;

  // Check if user has delete permissions (Super Admin/Super User roles)
  const canDelete =
    profileData?.companyRoles[0]?.role?.roleName === "Super Admin" ||
    profileData?.companyRoles[0]?.role?.roleName === "Super User" ||
    profileData?.companyRoles[0]?.role?.roleName === "Admin 3nStar";

  const [showAddShipmentButton, setShowAddShipmentButton] = useState(false);
  const [salesOrderNumberOptions, setSalesOrderNumberOptions] = useState([]);

  const serviceCenterAccess = profileData?.serviceCenterAccess || [];
  useEffect(() => {
    console.log("asbdjasdjsahk", selectedSalesOrderNumbers);
  }, [selectedSalesOrderNumbers]);

  // UNIFIED: Common fetch function that handles all parameters
  const fetchAllShipmentDetails = useCallback(
    async (options: FetchParams = {}) => {
      // Prevent API call if employee2 role

      if (isEmployee2) return;
      console.log("sasdas", selectedSalesOrderNumbers);

      // Build final parameters with current state as defaults
      const finalParams = {
        page: options.resetPagination ? 1 : options.page ?? currentPage,
        pageSize: options.pageSize ?? pageSize,
        sortBy: options.sortBy ?? sortField,
        sortOrder: options.sortOrder ?? sortOrder,
        searchValue: (options.searchValue ?? searchValue)?.trim(),
        searchFields: options.searchFields ?? searchFields,
        serviceCenterId: options.serviceCenterId ?? selectedServiceCenters,
        salesOrderNumber: options.salesOrderNumber ?? selectedSalesOrderNumbers,
        status: options.status ?? selectedStatus,
        refetchAgain: refetchAgain,
      };

      const currentParamsKey = JSON.stringify(finalParams);

      // OPTIMIZATION: Prevent duplicate API calls unless explicitly skipped
      // if (
      //   !options.skipDuplicateCheck &&
      //   (isApiCallInProgress.current ||
      //     lastApiCallParams.current === currentParamsKey)
      // ) {
      //   console.log("API call prevented - duplicate or in progress");
      //   return;
      // }

      try {
        isApiCallInProgress.current = true;
        lastApiCallParams.current = currentParamsKey;
        setIsLoading(true);
        setBaseLoading(true);

        console.log("Fetching with params:", finalParams);

        const response = await getApi("/shipment/service-centers", finalParams);
        const { total, data: shipmentDetails } = response.data.data;

        setAllShipmentData(shipmentDetails);
        setTotalRecords(total);

        // Update state if pagination was reset
        if (options.resetPagination) {
          setCurrentPage(1);
        }

        // Update state if new page/pageSize provided
        if (options.page !== undefined) {
          setCurrentPage(options.page);
        }
        if (options.pageSize !== undefined) {
          setPageSize(options.pageSize);
        }

        await refetchCounts();
      } catch (error: any) {
        const errorMessage =
          error.response?.data?.error?.message || "Failed to fetch shipments";
        const errorCode = error.response?.data?.error?.code;

        if (errorCode === 403) {
          toastText("You don't have permission to view shipments", "error");
        } else if (errorCode === 404) {
          toastText("No shipments found", "warning");
        } else {
          toastText(errorMessage, "error");
        }
      } finally {
        setIsLoading(false);
        setBaseLoading(false);
        isApiCallInProgress.current = false;
      }
    },
    [
      isEmployee2,
      currentPage,
      pageSize,
      sortField,
      sortOrder,
      searchValue,
      searchFields,
      selectedServiceCenters,
      selectedSalesOrderNumbers,
      selectedStatus,
      refetchAgain,
    ]
  );

  // OPTIMIZATION: Debounced fetch function for search
  const debouncedFetch = useCallback(
    (options: FetchParams = {}) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        console.log(202);
        fetchAllShipmentDetails(options);
      }, 300); // 300ms debounce delay
    },
    [fetchAllShipmentDetails]
  );

  const handleStatusChange = useCallback(
    (status: string[]) => {
      setSelectedStatus(status);

      // // Fetch with new status and reset pagination
      // fetchAllShipmentDetails({
      //   status: status,
      //   resetPagination: true,
      //   skipDuplicateCheck: true,
      // });
    },
    [fetchAllShipmentDetails]
  );
  const handleFilterCall = (salesOrderNumber: any, status: any) => {
    let payload: any = {};
    if (salesOrderNumber) {
      payload = {
        ...payload,
        salesOrderNumber,
      };
    }
    if (status) {
      payload = {
        ...payload,
        status,
      };
    }
    // Always call API to apply or clear filters
    fetchAllShipmentDetails({
      ...payload,
      resetPagination: true,
      skipDuplicateCheck: true,
    });
  };

  const handleCancel = useCallback(() => {
    setIsUploadShipmentModalOpen(false);
    setSelectedStatus([]);
    setFiltersReset(true);
  }, []);

  const showUploadShipmentModal = useCallback(() => {
    setSelectedRowKeys([]);
    setIsUploadShipmentModalOpen(true);
  }, []);

  const showAddShipmentManuallyModal = useCallback(() => {
    setSelectedRowKeys([]);
    setIsAddShipmentManuallModalOpen(true);
  }, []);

  const closeAddHolidayManuallyModal = useCallback(() => {
    setIsAddShipmentManuallModalOpen(false);
  }, []);

  const tableChangeHandler = useCallback(
    (pagination: any, filters: any, sorter: any) => {
      console.log("pagination", pagination);
      const newSortOrder =
        sorter?.order === "ascend" ? "asc" : sorter?.order ? "desc" : "";
      const newSortField = sorter.field || "";

      // Update local state
      setTotalRecords(pagination.total);
      setSortOrder(newSortOrder);
      setSortField(newSortField);
      console.log("249", pagination);
      // Fetch with new sorting and pagination
      fetchAllShipmentDetails({
        page: pagination.current,
        pageSize: pagination.pageSize,
        sortBy: newSortField,
        sortOrder: newSortOrder,
        skipDuplicateCheck: true,
      });
    },
    [fetchAllShipmentDetails]
  );

  const fetchUserAccess = useCallback(async () => {
    try {
      const response = await getApi(`/users/${userId}`);
      const { serviceCenterAccess } = response.data.data;

      if (
        roleName === "Admin 3nStar" ||
        (roleName === "3nStar Employee 1" && serviceCenterAccess.length > 0)
      ) {
        setShowAddShipmentButton(true);
      } else {
        setShowAddShipmentButton(false);
      }
    } catch (error) {
      console.error("Error fetching user access:", error);
      setShowAddShipmentButton(false);
    }
  }, [userId, roleName]);

  // Define the menu items
  const items: MenuProps["items"] = useMemo(
    () => [
      {
        key: "1",
        label: (
          <div onClick={showUploadShipmentModal}>
            <UploadOutlined style={{ marginRight: 8 }} />
            Upload Shipments
          </div>
        ),
      },
      {
        key: "2",
        label: (
          <div onClick={showAddShipmentManuallyModal}>
            <EditOutlined style={{ marginRight: 8 }} />
            Add Manually
          </div>
        ),
      },
    ],
    [showUploadShipmentModal, showAddShipmentManuallyModal]
  );

  // Initial load effect
  useEffect(() => {
    if (!isEmployee2) {
      console.log("309");
      fetchAllShipmentDetails({ skipDuplicateCheck: true });
    }
  }, []); // Only run on mount

  // Search effect with debouncing
  useEffect(() => {
    // Only fetch if:
    // 1. User is not Employee2
    // 2. Search value exists and has changed
    // 3. Search value is not empty after trimming
    if (!isEmployee2 && searchValue.trim() !== "") {
      const trimmedValue = searchValue?.trim();
      console.log("322");
      fetchAllShipmentDetails({
        searchValue: trimmedValue,
        resetPagination: true,
        skipDuplicateCheck: true,
      });
    }
  }, [searchValue]); // Only depend on searchValue changes

  // OPTIMIZATION: Optimized search handler
  const performSearchHandler = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSearchValue(value);

      // If search is cleared, fetch immediately
      if (value.trim() === "") {
        console.log("339");
        fetchAllShipmentDetails({
          searchValue: "",
          resetPagination: true,
          skipDuplicateCheck: true,
        });
      }
    },
    [fetchAllShipmentDetails]
  );

  // const searchFieldsSelectHandler = useCallback(
  //   (value: string[]) => {
  //     setSearchFields(value);

  //     // Fetch with new search fields
  //     if (searchValue.trim() !== "") {
  //       debouncedFetch({
  //         searchFields: value,
  //         searchValue: searchValue.trim(),
  //         resetPagination: true,
  //         skipDuplicateCheck: true,
  //       });
  //     } else {
  //       fetchAllShipmentDetails({
  //         searchFields: value,
  //         resetPagination: true,
  //         skipDuplicateCheck: true,
  //       });
  //     }
  //   },
  //   [searchValue, debouncedFetch, fetchAllShipmentDetails]
  // );

  const handleServiceCenterChange = useCallback(
    (data: any) => {
      // Update Redux state
      dispatch(
        setServiceCenterSelection({
          selectedServiceCenter: data,
          selectedServiceCenters: data,
        })
      );

      console.log("376");
      // Fetch with new service center filter
      fetchAllShipmentDetails({
        serviceCenterId: data,
        resetPagination: true,
        skipDuplicateCheck: true,
      });
    },
    [fetchAllShipmentDetails, dispatch]
  );

  const handleOk = (localStatus: any, localSalesOrderNumbers: any) => {
    setSelectedRowKeys([]);

    // Only clear selection, don't fetch
  };

  const handleSalesOrderNumberChange = (data: any, callAPI: boolean) => {
    console.log("callAPI", callAPI);
    setSelectedSalesOrderNumbers(data);

    // If callAPI is true, trigger the API call immediately
    if (callAPI) {
      fetchAllShipmentDetails({
        salesOrderNumber: data,
        resetPagination: true,
        skipDuplicateCheck: true,
      });
    }
  };

  // OPTIMIZATION: Memoized row selection
  const onSelectChange = useCallback((_: React.Key[], selectedRows: any[]) => {
    const selectedWithQuantity = selectedRows.map((row) => ({
      id: `${row.serviceCenterName}-${row.salesOrderNumber}`,
      quantity: row.quantity,
      shipmentId: row.shipmentId, // Store the actual shipment ID for deletion
    }));
    setSelectedRowKeys(selectedWithQuantity);
  }, []);

  const fetchSalesOrderNumber = async () => {
    try {
      const response = await getApi("/shipment/sales-order");
      console.log("response", response);
      if (response.data.data.length > 0) {
        setSalesOrderNumberOptions(
          response.data.data.map((center: any) => ({
            value: center.salesOrderNumber,
            label: center.salesOrderNumber,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const rowSelection = useMemo(
    () =>
      canDelete
        ? {
            selectedRowKeys: selectedRowKeys.map((item) => item.id),
            onChange: onSelectChange,
          }
        : undefined,
    [selectedRowKeys, onSelectChange, canDelete]
  );

  // Filter reset effect
  useEffect(() => {
    if (filtersReset) {
      console.log(446);
      // Reset all filters and fetch
      fetchAllShipmentDetails({
        page: 1,
        pageSize: 10,
        sortBy: "",
        sortOrder: "desc",
        searchValue: "",
        searchFields: SEARCHABLE_FIELDS.map((field) => field.value),
        serviceCenterId: [],
        salesOrderNumber: [],
        status: [],
        skipDuplicateCheck: true,
      });
      setFiltersReset(false);
    }
  }, [filtersReset]);

  const clearFilter = useCallback(() => {
    // Reset all filter states
    console.log("clearall");
    // Clear service center selection in Redux
    dispatch(
      setServiceCenterSelection({
        selectedServiceCenter: null,
        selectedServiceCenters: [],
      })
    );
    setSelectedSalesOrderNumbers([]);
    setSelectedStatus([]);
    setSearchValue("");
    setSearchFields(SEARCHABLE_FIELDS.map((field) => field.value));

    // Trigger filter reset
    setFiltersReset(true);
  }, [dispatch]);

  // Delete functionality
  const handleDeleteClick = useCallback(() => {
    if (selectedRowKeys.length > 0) {
      setIsDeleteModalOpen(true);
    }
  }, [selectedRowKeys]);

  const handleDeleteCancel = useCallback(() => {
    setIsDeleteModalOpen(false);
  }, []);

  const handleDeleteConfirm = useCallback(async () => {
    if (selectedRowKeys.length === 0) return;

    setIsDeleteLoading(true);
    try {
      const shipmentIds = selectedRowKeys.map((item) => item.shipmentId);

      // Delete each shipment individually
      const deletePromises = shipmentIds.map((id) =>
        deleteApiWithData("/shipment/delete", { shipmentId: id })
      );

      await Promise.all(deletePromises);

      toastText("Shipments deleted successfully", "success");
      setSelectedRowKeys([]);
      setIsDeleteModalOpen(false);
      // Refresh the data
      fetchAllShipmentDetails({
        resetPagination: true,
        skipDuplicateCheck: true,
      });
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error?.message || "Failed to delete shipments";
      toastText(errorMessage, "error");
    } finally {
      setIsDeleteLoading(false);
    }
  }, [selectedRowKeys, fetchAllShipmentDetails]);

  // // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      isApiCallInProgress.current = false;
      lastApiCallParams.current = "";
    };
  }, []);

  const [dateUpdated, setDateUpdated] = useState(false);

  const changeDateState = (prev) => {
    setDateUpdated((prec) => !prev);
  };

  return (
    <>
      <div>
        <TableActionHeader title={"Shipment"}>
          {!isServiceCenter && (
            <div>
              <Dropdown menu={{ items }} placement="bottomLeft">
                <button className={`btn-blue`}>
                  <AddSvg /> Add Shipment
                </button>
              </Dropdown>
            </div>
          )}
        </TableActionHeader>

        <UploadShipmentModal
          isUploadModalOpen={isAddShipmentModalOpen}
          handleCancel={handleCancel}
          fetchShipment={fetchAllShipmentDetails}
          fetchSalesOrderNumber={fetchSalesOrderNumber}
          clearFilter={clearFilter}
        />
        <AddShipmentManuallyModal
          isVisible={isAddShipmentManuallyModalOpen}
          handleCancel={closeAddHolidayManuallyModal}
          selectedShipment={selectedShipment}
          setSelectedShipment={setSelectedShipment}
          fetchAllShipmentDetails={fetchAllShipmentDetails}
          fetchSalesOrderNumber={fetchSalesOrderNumber}
          clearFilter={clearFilter}
          selectedSalesOrderNumbers={selectedSalesOrderNumbers}
          selectedStatus={selectedStatus}
        />

        <ShipmentTable
          changeDateState={changeDateState}
          handleStatusChange={handleStatusChange}
          allShipmentData={allShipmentData}
          isLoading={isLoading}
          setSelectedShipment={setSelectedShipment}
          openModalHandler={showAddShipmentManuallyModal}
          totalRecords={totalRecords}
          searchValue={searchValue}
          searchFields={searchFields}
          performSearchHandler={performSearchHandler}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          fetchShipments={fetchAllShipmentDetails}
          tableChangeHandler={tableChangeHandler}
          isServiceCenter={isServiceCenter}
          rowSelection={rowSelection}
          setSelectedRowKeys={setSelectedRowKeys}
          selectedRowKeys={selectedRowKeys}
          sortDirection={sortOrder}
          handleServiceCenterChange={handleServiceCenterChange}
          selectedServiceCenter={selectedServiceCenters}
          handleOk={handleOk}
          handleSalesOrderNumberChange={handleSalesOrderNumberChange}
          selectedSalesOrderNumbers={selectedSalesOrderNumbers}
          setFiltersReset={setFiltersReset}
          fetchShipment={fetchAllShipmentDetails}
          salesOrderNumberOptions={salesOrderNumberOptions}
          fetchSalesOrderNumber={fetchSalesOrderNumber}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          baseLoading={baseLoading}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
          recordId={selectedRecordId}
          setSelectedRecordId={setSelectedRecordId}
          setRefetchAgain={setRefetchAgain}
          handleFilterCall={handleFilterCall}
          clearFilter={clearFilter}
          handleDeleteClick={handleDeleteClick}
          canDelete={canDelete}
        />

        <ConfirmDelete
          isModalOpen={isDeleteModalOpen}
          handleCancel={handleDeleteCancel}
          handleOk={handleDeleteConfirm}
          deleteHandler={handleDeleteConfirm}
          isAddUserLoading={isDeleteLoading}
          warningMessage="Deleting this record will affect Shipments, Receive Inventory, Spare Parts Inventory and Register Spare Parts. This action cannot be undone. Proceed only if you are certain."
        />
      </div>
    </>
  );
};

export default ShipmentComponent;
